import {
  UserAccountsService,
  UserPlanCount,
  UserSatisfactionService,
} from '../services';
import { EventMapService } from '../services';
import { CAMPAIGN_EVALUATION_REWARD_ARTS } from './campaignEvaluationSession';

export async function submitCampaignEvaluation({
  rating = 0,
  origin = 'campaignChatSocket',
  campaignId = null,
}) {
  const { responseStatus } = await UserSatisfactionService.postUserSatisfaction({
    userRating: rating,
    userComment: '',
    origin,
  });

  if (responseStatus !== 200 && responseStatus !== 204) {
    return { success: false };
  }

  if (campaignId) {
    await EventMapService.postEventMap({
      event: 'campaign_user_satisfaction',
      eventData: {
        campaignId,
        rating,
      },
    });
  }

  const userPlanCount = await UserPlanCount.getUserPlanCountByUser();
  if (userPlanCount?.data?.uuid) {
    await UserPlanCount.putUserPlanCount(userPlanCount.data.uuid, {
      nonExpiringAdditionalSinglePostCount:
        Number(userPlanCount.data.nonExpiringAdditionalSinglePostCount ?? 0) +
        CAMPAIGN_EVALUATION_REWARD_ARTS,
    });
  }

  const userAccountResponse = await UserAccountsService.getUserAccountsByLogin();
  if (userAccountResponse?.data) {
    await UserAccountsService.putUserAccountsByLogin({
      userId: userAccountResponse.data.userId,
      campaingAvaliation: true,
    });
  }

  return { success: true };
}
